import { useEffect, useState } from 'react'
import useUserToken from './useToken'
import { appConfig } from '../constants/config/appConfig'


const useAuthenticate = () => {
  const [token] = useUserToken(appConfig.SESSION_USER_TOKEN)
  
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    if (!token) return false
    return true
  })

  // Effect to update the value whenever the token changes
  useEffect(() => {
    if (!token) {
      setIsAuthenticated(false)
    } else {
      setIsAuthenticated(true)
    }
  }, [token])

  // Return the user object
  return [isAuthenticated]
}

export default useAuthenticate
